var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('img',{attrs:{"src":_vm.getUrl()}}):_c('img',{attrs:{"src":_vm.defaultImageSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }